import React from 'react';
import { employerAccessTypes } from './actions'
import {formatMoney} from '../../utils'


const initialState = {
    isFetching: false,
    data: {
        kennitala: null,
        access: [],
    },
    // Current company 0
    currentCompany: {
        name: "",
        company_id: ""
    },
    // Sýna fyrirtækjaval (default false)
    showCompanySelection: false,
    error: "",
    employerAccessError: "",
    create: {}
}


export function employerAccess(state = initialState, action) {
    let existing = null


    switch(action.type) {

        
        
        case employerAccessTypes.REQUEST_ACTIVATE:
            state = {...state, isFetching: false, error: ""}
            return state
        case employerAccessTypes.RECEIVE_ACTIVATE:
            state = {...state, isFetching: false, error: ""}
            state.data = action.data
            if(action.data.access.filter(f => f.active).length >= 1){
                state.currentCompany = action.data.access.filter(f => f.active)[0].company
            }
            state.showCompanySelection = (action.data.access.filter(f => f.active).length > 1 ? true : false)
            return state
        case employerAccessTypes.ERROR_ACTIVATE:
            state = {...state, isFetching: false, error: "Villa kom upp. Vinsamlegast athugaðu hvort þú hafir slegið inn rétt lykilorð úr netbanka. Lykilorð gæti einnig verið útrunnið ef það er meira en 3ja daga gamalt."}
            return state
                    
        case employerAccessTypes.REQUEST:
            state = {...state}
            state.employerAccessError = ""
            state.isFetching = true
            state.create = action.create
            return state
        case employerAccessTypes.ERROR:
            state = {...state, employerAccessError: action.error.error}
            state.isFetching = false
            state.create = action.create
            return state
        case employerAccessTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.data = action.data
            state.employerAccessError = ""
            
            if(action.data.access.filter(f => f.active).length >= 1){
                state.currentCompany = action.data.access.filter(f => f.active)[0].company
            }
            state.showCompanySelection = (action.data.access.filter(f => f.active).length > 1 ? true : false)
            state.create = action.create

            return state

        default:
            return state
    }
}